export default __webpack_public_path__ + "static/0012-e39971a0fc9a8aafb4f6a395ecfd0805.png";